import type { TSkeletons } from '@frontend/pole-ui/lib/components/Skeleton'

export const LOAN_CARD_SKELETONS: TSkeletons = [{ className: 'loanCard' }, { className: 'loanCard' }, { className: 'loanCard' }]
